import { render } from "./OnlinePage.vue?vue&type=template&id=5fed5f7c&scoped=true&ts=true"
import script from "./OnlinePage.vue?vue&type=script&lang=ts"
export * from "./OnlinePage.vue?vue&type=script&lang=ts"

import "./OnlinePage.vue?vue&type=style&index=0&id=5fed5f7c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fed5f7c"]])

export default __exports__